import _ from 'lodash';
import { useMemo } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useTextFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';
import { useFunnelData } from 'utils/funnel-data-context';
import { buildImgProps } from 'utils/media';

import { ComponentsFooter } from 'queries/graphql';

// import SubscriptionForm from './components/SubscriptionForm';

import styles from './styles.module.scss';

export function FunnelFooter({
  logo,
  brandName,
  privacyPolicyUrl,
  termsAndConditionsUrl,
  refundsUrl,
  contactUsUrl,
  style,
}: ComponentsFooter) {
  const { links: footerLinks } = useFunnelData();
  const { textFont, textColor, backgroundColor, linkHoverColor } = style || {};

  const textFontOverrides = useTextFontOverrides(textFont);

  const privacyPolicyLink = useMemo(() => {
    return !_.isEmpty(privacyPolicyUrl) ? privacyPolicyUrl : footerLinks.privacyPolicy;
  }, [privacyPolicyUrl, footerLinks.privacyPolicy]);

  const termsAndConditionsLink = useMemo(() => {
    return !_.isEmpty(termsAndConditionsUrl)
      ? termsAndConditionsUrl
      : footerLinks.termsAndConditions;
  }, [termsAndConditionsUrl, footerLinks.termsAndConditions]);

  const refundsLink = useMemo(() => {
    return !_.isEmpty(refundsUrl) ? refundsUrl : footerLinks.refundPolicy;
  }, [refundsUrl, footerLinks.refundPolicy]);

  const contactUsLink = useMemo(() => {
    return !_.isEmpty(contactUsUrl) ? contactUsUrl : footerLinks.contactUs;
  }, [contactUsUrl, footerLinks.contactUs]);

  return (
    <footer className={`root ${styles.footer}`} id="footer">
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-dark)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--secondary-color)')}
          ${buildCssVar('--link-hover-color', linkHoverColor, textColor, 'var(--text-color-dark)')}
          ${textFontOverrides ?? ''}
        }
      `}</style>

      {logo && (
        <div className={styles.footer_logo}>
          <Image {...buildImgProps(logo)} alt={`${brandName} Logo`} />
        </div>
      )}
      <div className={styles.links}>
        <Link href={privacyPolicyLink} legacyBehavior>
          <a target="_blank" className={styles.link}>
            Privacy Policy
          </a>
        </Link>
        <Link href={termsAndConditionsLink} legacyBehavior>
          <a target="_blank" className={styles.link}>
            Terms & Conditions
          </a>
        </Link>
        <Link href={refundsLink} legacyBehavior>
          <a target="_blank" className={styles.link}>
            Returns & Refunds
          </a>
        </Link>
        <Link href={contactUsLink} legacyBehavior>
          <a target="_blank" className={styles.link}>
            Contact Us
          </a>
        </Link>
      </div>
      <p className={styles.copyright}>
        {brandName} © {new Date().getFullYear()} — All Rights reserved.
      </p>
    </footer>
  );
}
